import StoredLayout from '../../layouts/StoredLayout'
import Sliders from './Sliders'
export default StoredLayout(Sliders)



// WEBPACK FOOTER //
// ./src/forms/sliders/index.js